export default __webpack_public_path__ + "711493f294b58712c86b6aec7a27ccfe.png";